import React, { useEffect, useState } from "react";
import { Ban, BadgeCheck, Loader2 } from "lucide-react";
import Modal from "@/components/chat/Modal";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { getInitials, avatarColor } from "@/lib/avatar";
import { toast } from "sonner";

export default function BlockedContactsDialog({ onClose }) {
  const { user, setUser } = useAuth();
  const { t } = useI18n();
  const [list, setList] = useState(null);

  const load = async () => {
    try { const { data } = await api.get("/users/blocked"); setList(data); }
    catch (e) { setList([]); }
  };
  useEffect(() => { load(); }, []);

  const unblock = async (id) => {
    try {
      await api.post(`/users/${id}/unblock`);
      setList((l) => l.filter((u) => u.id !== id));
      setUser({ ...user, blocked: (user.blocked || []).filter((b) => b !== id) });
      toast(t("unblocked_toast"));
    } catch (e) { toast.error("Failed"); }
  };

  return (
    <Modal title={t("blocked_contacts")} onClose={onClose}>
      <div data-testid="blocked-contacts-dialog">
        {list === null ? (
          <div className="py-16 grid place-items-center text-[var(--rc-muted)]"><Loader2 className="animate-spin" /></div>
        ) : list.length === 0 ? (
          <div className="py-16 text-center">
            <div className="h-16 w-16 mx-auto rounded-full grid place-items-center bg-[var(--rc-surface)] text-[var(--rc-muted)] mb-3"><Ban size={26} /></div>
            <p className="text-[var(--rc-muted)]" data-testid="no-blocked-msg">{t("no_blocked")}</p>
          </div>
        ) : (
          <div className="divide-y divide-[var(--rc-border)]">
            {list.map((u) => (
              <div key={u.id} className="flex items-center gap-3 py-3" data-testid={`blocked-item-${u.id}`}>
                <div className="h-11 w-11 rounded-full grid place-items-center text-[var(--rc-gold)] text-sm font-semibold overflow-hidden shrink-0 border-2 border-[var(--rc-gold)]" style={{ backgroundColor: avatarColor(u.name) }}>
                  {u.avatar ? <img src={u.avatar} alt="" className="h-full w-full object-cover" /> : getInitials(u.name)}
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-1.5 truncate">
                    <span className="truncate">{u.name}</span> {u.flag}
                    {u.email_verified && <BadgeCheck size={14} className="text-[var(--rc-gold)] shrink-0" />}
                  </div>
                </div>
                <button onClick={() => unblock(u.id)} data-testid={`unblock-${u.id}`}
                  className="shrink-0 rounded-full border border-[var(--rc-gold)]/50 text-[var(--rc-gold)] text-sm font-medium px-4 py-1.5">
                  {t("unblock")}
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
}
